var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "toast mb-3 fade",
      class: { show: _vm.isVisible },
      attrs: { role: "alert", "aria-live": "assertive", "aria-atomic": "true" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "toast-body" }, [
        _vm._v("Товар "),
        _c("b", [_vm._v("«" + _vm._s(_vm.lastAddedName) + "»")]),
        _vm._v(" добавлен в таблицу сравнения."),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toast-header bg-info text-white" }, [
      _c("i", {
        staticClass: "mr-2",
        staticStyle: { width: "1.25rem", height: "1.25rem" },
        attrs: { "data-feather": "info" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "font-weight-semibold mr-auto" }, [
        _vm._v("Добавлено в сравнения!"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close text-white ml-2 mb-1",
          attrs: {
            type: "button",
            "data-dismiss": "toast",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }